<template>
  <div class="empty-cards-root">
    <img
      src="../../../shared/assets/images/cubics-with-cards.png"
      alt=""
      height="220px"
      width="220px"
    />
    <h2 class="title">{{ $t('WithdrawToCard | emptyCardsTitle') }}</h2>
    <p class="description">
      {{ $t('WithdrawToCard | emptyCardsDescription') }}
    </p>
    <base-button type="cta" class="action" @onClick="$emit('add-new-card')">
      {{ $t('WithdrawToCard | emptyCardsAction') }}
    </base-button>
  </div>
</template>

<script>
import BaseButton from '@/shared/ui/BaseButton/BaseButton.vue'

export default {
  components: {
    BaseButton,
  },
}
</script>

<style scoped lang="scss">
.empty-cards-root {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.title {
  color: var(--text-1);
  font-size: 25px;
  font-style: normal;
  font-weight: 600;
}

.description {
  max-width: 252px;
  color: var(--text-6);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
}

.action {
  margin-top: 30px;
}
</style>
